import { NOTIFICATION_CHANNEL } from "@nlc/shared-types";
import { SuprSend } from "@suprsend/react";
import { X } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/button";
import { Input } from "@/components/field";
import { Label } from "@/components/field";
import { Modal } from "@/components/modal";
import { env } from "@/config/env";
import { useUser } from "@/hooks/useUser";

import { useConnectChannel } from "../../hooks/useConnectChannel";
import ConnectButton from "./ConnectButton";
import { SelectPrefix } from "./SelectPrefix";

export function WhatsAppConfig() {
  const [openModal, setOpenModal] = useState(false);
  const onClose = () => setOpenModal(false);
  const { mutate: connectChannel } = useConnectChannel();

  return (
    <div className="flex">
      <ModalWhatsapp
        onClose={onClose}
        onConnect={() => connectChannel(NOTIFICATION_CHANNEL.WHATSAPP)}
        openModal={openModal}
      />
      <ConnectButton isDisabled onPress={() => setOpenModal(true)} />
    </div>
  );
}

function ModalWhatsapp({
  onClose,
  onConnect,
  openModal,
}: {
  onClose: () => void;
  onConnect: () => void;
  openModal: boolean;
}) {
  const [prefix, setPrefix] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const { data: user } = useUser();
  const suprSendClient = new SuprSend(env.VITE_SUPRSEND_PUBLIC_KEY);

  const handleAddWhatsapp = async () => {
    setLoading(true);

    await suprSendClient.identify(user?.user.email);
    await suprSendClient.user.addWhatsapp(`${prefix}${phone}`);
    onConnect();
    setLoading(false);
    onClose();
  };

  return (
    <Modal isOpen={openModal} onOpenChange={onClose}>
      <div className="p-8">
        <div className="flex justify-between mb-3">
          <p className="text-text-quaternary font-bold pb-3 text-base">
            Whatsapp configuration
          </p>
          <X
            className="text-text-quaternary cursor-pointer"
            onClick={onClose}
          />
        </div>
        <SelectPrefix setValue={setPrefix} value={prefix} />
        <div className="mt-4">
          <Label requiredHint>Phone number</Label>
          <Input className="mt-1" onChange={(e) => setPhone(e.target.value)} />
        </div>
        <div className="flex mt-4 justify-end">
          <Button onPress={onClose} variant="secondary">
            Cancel
          </Button>
          <Button
            className="flex flex-row items-center mt-auto ml-2"
            isDisabled={prefix === "" || phone === ""}
            isLoading={loading}
            onPress={handleAddWhatsapp}
          >
            Connect
          </Button>
        </div>
      </div>
    </Modal>
  );
}
